"use client";

import React from 'react';
import { Switch } from '@/components/ui/Switch';
import { cn } from '@/lib/utils';

interface PreferenceToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function PreferenceToggle({ checked, onChange, disabled, className }: PreferenceToggleProps) {
  return (
    <div className={cn('flex items-center justify-between gap-3 rounded-xl border border-border/60 bg-muted/30 px-3 py-2', className)}>
      <div>
        <p className="text-sm font-medium text-foreground">Save these changes as a client preference</p>
        <p className="text-xs text-muted-foreground">Apply this guidance to future drafts for this client.</p>
      </div>
      <Switch
        checked={checked}
        onChange={(e) => onChange((e.target as HTMLInputElement).checked)}
        disabled={disabled}
        aria-label="Save as client preference"
      />
    </div>
  );
}
